import owd from 'owd/owd';

export default class ProductsOptionsToggle extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('click', (e) => {
            this.$element.toggleClass('open');

            if (this.$element.hasClass('open')) {
                $('.products-options').addClass('open');
                $('[data-slider]').trigger('visibilitychanged');
            } else {
                $('.products-options').removeClass('open');
            }
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('products-options-toggle', {
	component: ProductsOptionsToggle
});
